import {
  Box,
  Button,
  Divider,
  Grid,
  Group,
  Modal,
  MultiSelect,
  Paper,
  Popover,
  ScrollArea,
  Select,
  Stack,
  Switch,
  Text,
  Title,
  Textarea,
  Image,
  SimpleGrid,
  Skeleton,
  Badge,
  useMantineTheme,
} from "@mantine/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { logger } from "utils/logger";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { getClientLabel, getStatusColor, handleZipDownload, pluralize } from "utils/helper";

import {
  CheckboxDropdown,
  Crumbline,
  FilterButton,
  FlagToggle,
  FormInputWrapper,
  StarRating,
} from "../../../../core/components";
import {
  CaptureNoteEditor,
  NoteEditorState,
} from "../../../../core/components/capture/CaptureNoteEditor";

import { SampleStatusTypes } from "core/models/SampleModel";
import { useAbortController } from "core/hooks/useAbortableController";
import { ListViewOption } from "core/components/listToggle/listToggleControl";
import {
  IconAdjustmentsHorizontal,
  IconCheck,
  IconClearAll,
  IconDownload,
  IconNote,
} from "@tabler/icons-react";
import { isDate } from "moment";
import CustomDatePicker from "core/components/datePicker/CustomDatePicker";
import StyleMediaList from "./StyleMediaList";
import styles from "./Style.module.scss";

import { CaptureEventType } from "core/components/capture/CaptureThumb";
import { AppConstants, StudioStatusTypes } from "utils/constants";
import { useLocalStorage } from "@mantine/hooks";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import {
  fetchApprovalSelects,
  fetchStyleMeta,
  getStyleSuccess,
  selectStyle,
  setSessionCaptures,
  setStyleMediaFilter,
  updateStudioSession,
} from "modules/Wip/wipSlice";
import { selectItems } from "utils/helper";
import _ from "lodash";
import AssetViewer from "core/components/approval/AssetViewer";
import CaptureFilterPanel from "core/components/capture/CaptureFilterPanel";
import { MediaFilterModel } from "core/models";

const Style = ({
  user,
  style,
  styleMediaFilter,
  setStyleMediaFilter,
  setStyleFilter,
  success,
  error,
  productionWipList,
}) => {
  const dispatch = useDispatch();
  // const { classes } = useStyles();
  const [listView, setListView] = useState(ListViewOption.LIST);
  const [approvalType, setApprovalType] = useState(null);

  const params = useParams();
  const [activeTab, setActiveTab] = useState("styles");
  const navigate = useNavigate();
  const hasInit = useRef(false);
  const abortController = useAbortController();
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [wipData, setWipData] = useState([]);
  const [filterItems, setFilterItems] = useState(styleMediaFilter);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [selectedItems, setSelectedItems] = useState([]);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [completionNotes, setCompletionNotes] = useState("");

  const theme = useMantineTheme();
  const [displaySettings, setDisplaySettings] = useLocalStorage({
    key: "op-style-display-settings",
    defaultValue: {
      imageFit: "cover",
      showMeta: true,
      imageSize: "300",
    },
  });

  useEffect(() => {
    logger.log(success);
    if (success) {
      switch (success.type) {
        case getStyleSuccess.toString(): {
          setIsLoading(false);
          break;
        }
      }
    }
  }, [success]);

  // get the style from the url
  useEffect(() => {
    logger.log(params);
    if (
      params &&
      params.styleNumber &&
      (!style || (style && style.styleNumber !== params.styleNumber)) &&
      params.sessionId &&
      !hasInit.current
    ) {
      hasInit.current = true;
      // fetch the styles
      dispatch(fetchStyleMeta(params.sessionId, params.styleNumber));

      // fetch the post production tasks
      dispatch(fetchApprovalSelects({}));
    } else if (!hasInit.current) {
      hasInit.current = true;

      dispatch(fetchStyleMeta(params.sessionId, params.styleNumber));
    }
  }, [params]);

  const form = useForm({
    initialValues: {
      ...style,
      name: "",
      deadline: new Date(2021, 11, 5),
    },

    validate: {
      // email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
    },
  });

  useEffect(() => {
    const deadline = style && style.deadline ? new Date(style.deadline) : "";
    form.setValues({ ...style, deadline: deadline });
  }, [style]);

  const onFormSubmit = (vals) => {
    logger.log("Submitting form");
    const data = {
      id: style.id,
      code: form.values.code,
      name: form.values.name,
      description: form.values.description,
      deadline: form.values.deadline,
      tags: form.values.tags.join(","),
      // team:form.values.team,
      // ts:form.values.ts,
    };
    // dispatch(updateSeason(data, user));
  };

  const crumbItems = [
    { title: "WIP", route: "/wip", search: "" },
    { title: "Production", route: "/wip/production", search: "" },
    { title: params.styleNumber ?? "", route: `wip/${params.styleNumber}` },
  ];

  /**
   * Effect to handle location change
   */

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let displayType = params.get("displayType");

    const path = location.pathname;
    const type = path.split("/")[2];
    if (type && type !== approvalType) setApprovalType(type);

    logger.log(
      "location change ",
      location,
      " DISPLAY: ",
      displayType,
      params,
      listView
    );
    // if display type changes
    if (displayType && displayType !== listView) setListView(displayType);
  }, [location]);

  const onStatusClick = (type, data) => {
    switch (type) {
      // if they have clicked on the photography count then we want to filter
      // the media based on the style code
      // case SampleStatusTypes.SAMPLE_PHOTOGRAPHY_COUNT:{
      //     const filter = {...mediaFilter,styles:[data.stylenumber]};
      //     setMediaFilter(filter);

      //     // nav to the media tab
      //     onTabChange('media');
      //     break;
      // }
      // case SampleStatusTypes.SAMPLE_TASK_COUNT:{
      //     const filter = {...taskFilter,styles:[data.stylenumber]};
      //     setTaskFilter(filter);

      //     // nav to the media tab
      //     onTabChange('tasks');
      //     break;
      // }
      case SampleStatusTypes.SAMPLE_SCAN_COUNT: {
        // take them too the scan
        navigate(`/warehouse/scans/${data.scan.gid}`);
        logger.log(data);
        break;
      }
      default: {
        break;
      }
    }
  };

  const setFilterVars = (vals) => {
    logger.log(vals);
    setStyleMediaFilter(vals);
  };
  const filterWips = useCallback(() => {
    // var data = filterSamples(wips, styleMediaFilter);
    // setWipData(data);
  }, [
    styleMediaFilter.brands,
    styleMediaFilter.categories,
    setWipData,
    styleMediaFilter.groupBy,
    styleMediaFilter.keyword,
  ]);

  useEffect(() => {
    //setWipData(wips);

    // set the brands/season/category
    // var styleNumbers = {};
    // var sessions = {};
    // var seasons = {};
    // var statuses = {};
    // var talents = {};
    var tags = {};
    // var depts = {};
    // var sizes = {};

    // wips?.forEach((item, idx) => {
    //   styleNumbers[item.ssSort] = item;
    //   sessions[item.sessionCode] = item;
    //   seasons[item.seasonCode] = item;
    //   // statuses[item.status] = item;
    //   talents[item.talentNames] = item;
    //   issuers[item.issuer] = item;
    //   depts[item.dept] = item;
    //   sizes[item.size] = item;
    // });
    style?.assets?.forEach((item, idx) => {
      // item.tags is a string split it by comma and then add it to the tags object
      item.tags.split(",").forEach((tag, idx) => {
        tags[tag.trim()] = item;
      });
      // tags[item.tags] = item;
    });

    setFilterItems({
      tags,
    });

    // setFilterItems({
    //   styleNumbers,
    //   sessions,
    //   seasons,
    //   // statuses,
    //   talents,
    //   depts,
    //   issuers,
    //   sizes,
    // });

    filterWips();
  }, [filterWips, style]);

  logger.log(style);

  const getFilterCount = (val) => {
    var count = 0;

    const dateKeys = ["otbDate", "distribution", "completed"];
    const ignoreKeys = ["groupBy", "starComparison"];

    Object.entries(val).forEach(([key, value]) => {
      if (value && value.length && ignoreKeys.indexOf(key) === -1) {
        ++count;
      }

      if (key === "status") {
        var statusCount = 0;
        Object.entries(value).forEach(([key, value]) => {
          if (value.length) {
            statusCount = 1;
          }
        });

        count += statusCount;
      }

      if (dateKeys.indexOf(key) > -1) {
        if (isDate(value.dateStart) || isDate(value.dateEnd)) {
          ++count;
        }
      }
    });

    return count;
  };

  useEffect(() => {
    const count = getFilterCount(styleMediaFilter);
    setFilterCount(count);
  }, [styleMediaFilter]);

  const onClearClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();

    setStyleMediaFilter({
      ...new MediaFilterModel({ groupBy: styleMediaFilter.groupBy }),
    });

    // setWipFilter({ ...new SampleFilterModel({ groupBy: styleMediaFilter.groupBy }) });

    logger.log("CLEAR CLICK", e);
  };

  /**
   * Handles the list toggle display
   * @param {*} val
   */
  const listToggleHandler = (val) => {
    navigate({ search: `?displayType=${val}` });
  };

  const filterButtonHandler = (e) => {
    logger.log("BUTTON CLICK", e, e.nativeEvent);
    setFilterOpen((o) => !o);
  };

  /**
   * Handler for when a capture is selected.
   * @param {*} item
   * @param {*} selected
   */
  const onItemSelected = (e, item, selected) => {
    var items = [...selectedItems];

    // Use wipData as the page items since that represents the current filtered data
    const pageItems = style.assets.map((val) => {
      // Handle both flat data and grouped data structure
      return val.original ? { ...val.original } : { ...val };
    });

    if (item.type && item.type === "group") {
      // select all the sub items.
      let subItems = [...item.subRows];
      if (selected) {
        subItems.forEach((val) => {
          selectItems(e, val, selected, pageItems, items);
        });
      } else {
        items = _.differenceBy(items, subItems, "id");
      }
    } else {
      // call general helper to select items
      selectItems(e, item, selected, pageItems, items);
    }

    setSelectedItems(items);
    //dispatch(selectTasks(items));
    //selectTask(items);
  };

  const onMediaAction = (e, val, originalEvent, items) => {
    logger.log(e);
    switch (e) {
      case CaptureEventType.IMAGE_CLICK: {
        setSelectedAsset(val);
        setImageModalOpen(true);
        break;
      }
      case CaptureEventType.SELECT_CLICK: {
        // setSelectedItems(items);
        const selected = !selectedItems.find((item) => item.id === val.id);
        onItemSelected(originalEvent, val, selected);
        break;
      }
      default: {
        break;
      }
    }
    logger.log(e, val, items);
  };

  const onChange = (vals) => {
    setDisplaySettings(vals);
  };

  const onCaptureChange = (type, data, items) => {
    logger.log(type, data, items);
    switch (type) {
      case CaptureEventType.RATING_CHANGE: {
        const tmpItems = items.map((val) => {
          return {
            star: data.data.toString(),
            actionPart: val.actionPart,
            actionSort: val.actionSort,
          };
        });
        dispatch(setSessionCaptures(tmpItems, user));
        break;
      }
      case CaptureEventType.STATUS_CHANGE: {
        const tmpItems = items.map((val) => {
          return {
            sak: data.data.toString(),
            actionPart: val.actionPart,
            actionSort: val.actionSort,
          };
        });
        dispatch(setSessionCaptures(tmpItems, user));
        break;
      }
      case CaptureEventType.NOTES_CHANGE: {
        const tmpItems = items.map((val) => {
          return {
            clientNotes: data.data.toString(),
            actionPart: val.actionPart,
            actionSort: val.actionSort,
          };
        });
        dispatch(setSessionCaptures(tmpItems, user));
        break;
      }
      case CaptureEventType.DOWNLOAD: {
        // find all the items
        const extension = data.type && data.type === "eipURL" ? "eip" : "png";
        handleZipDownload(
          items,
          "originalFilename",
          style.styleNumber,
          data.type,
          extension
        );
        break;
      }
      case CaptureEventType.SHOW_BATCH_NOTES_EDITOR: {
        // find all the items
        // open modal with the notes editor
        modals.open({
          title: "Batch Update Approval Notes",
          size: "md",
          children: (
            <Stack>
              <Text size="sm" c="dimmed">
                Enter the notes below to update the notes for the (
                {items?.length}) selected items
              </Text>
              <CaptureNoteEditor
                defaultState={NoteEditorState.EDITING}
                notes={selectedItems[0]?.clientNotes || ""}
                onNotesChange={(newNotes) => {
                  // Handle notes change by calling the existing onCaptureChange function
                  onCaptureChange(
                    CaptureEventType.NOTES_CHANGE,
                    { data: newNotes },
                    selectedItems
                  );
                  modals.closeAll();
                }}
              />
            </Stack>
          ),
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  const onSelectAll = () => {
    setSelectedItems(
      selectedItems.length === style?.assets?.length ? [] : style?.assets
    );
  };

  /**
   * Handler for the Capture menu events.
   * @param {*} e
   * @param {*} data
   * @param {*} items
   */
  const onMenuItemClick = (e, data, items) => {
    logger.log(e);
    var captures = [];
    switch (e) {
      case CaptureEventType.DOWNLOAD: {
        // find all the items
        const arr = items.map((val) => {
          const item = style.assets.find((session) => val.id === session.id);
          if (item) return item;
        });
        const extension = data.type && data.type === "eipURL" ? "eip" : "png";
        handleZipDownload(
          arr,
          "originalFilename",
          style.styleNumber,
          data.type,
          extension
        );
        break;
      }
      case CaptureEventType.COLOUR_CHANGE:
      case CaptureEventType.RATING_CHANGE:
      case CaptureEventType.STATUS_CHANGE: {
        captures = items.map((val) => {
          return style.assets.find((obj) => obj.id === val.id);
        });

        onCaptureChange(e, data, captures);
        break;
      }
      case CaptureEventType.BATCH_CREATE_TASK:
      case CaptureEventType.APPLY_STYLE_INFO:
      case CaptureEventType.CREATE_TASK: {
        captures = items.map((val) => {
          return style.assets.find((obj) => obj.id === val.id);
        });

        onMediaAction(e, data, captures);
        break;
      }
      case CaptureEventType.MARK_COMPLETED: {
        captures = items.map((val) => {
          return style.assets.find((obj) => obj.id === val.id);
        });
        const { sessionCode, styleNumber, clientProdStatus, notes } = data;
        dispatch(
          updateStudioSession(
            { sessionCode, styleNumber, clientProdStatus, notes },
            user
          )
        );
        // dispatch(updateStudioSession(data, user));
        break;
      }
      case CaptureEventType.SHOW_BATCH_NOTES_EDITOR: {
        // open modal with the notes editor
        onCaptureChange(e, data, items);
        break;
      }
      // case CaptureEventType.TAG_TALENT: {
      //   setShowTagTalent(true);
      //   break;
      // }
      default: {
        break;
      }
    }
  };

  const selectAllMenu = (
    <div>
      <Button
        variant="default"
        className={"select-all-menu-button"}
        leftSection={<IconDownload size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.DOWNLOAD,
            { data: null, type: "loURL" },
            selectedItems
          )
        }
      >
        Download {pluralize("Image", selectedItems.length)}
      </Button>

      {/* <Button variant='default' leftIcon={<IconDownload size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.DOWNLOAD, { data: null, type: 'eipURL' }, selectedItems)}>
            Download EIP
        </Button> */}
      <Button
        variant="default"
        className={"select-all-menu-button"}
        leftSection={<IconNote size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.SHOW_BATCH_NOTES_EDITOR,
            { data: null },
            selectedItems
          )
        }
      >
        Batch Update Notes
      </Button>

      <Button
        variant="default"
        className={"select-all-menu-button"}
        leftSection={<IconClearAll size={14} />}
        onClick={(e) => setSelectedItems([])}
      >
        Deselect All
      </Button>
      {/* <Button variant='default' leftIcon={<IconSubtask size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.CREATE_TASK, { data: null }, selectedItems)}>
            Create Task
        </Button> */}
      {/* <Button variant='default' leftIcon={<IconColorSwatch size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.APPLY_STYLE_INFO, { data: null }, selectedItems)}>
            Apply Styles
        </Button>

        <Button variant='default' leftIcon={<IconUserCheck size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.TAG_TALENT, { data: null }, selectedItems)}>
            Tag Talent
        </Button> */}

      {/* <Button variant='default' leftIcon={<IconArchive size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.ARCHIVE, { data: null }, selectedItems)}>
            Archive Assets
        </Button> */}

      {/* {mediaFilter.groupBy === "styles" ? (
        <Button
          variant="default"
          leftIcon={<IconChecklist size={14} />}
          onClick={(e) =>
            onMenuItemClick(
              CaptureEventType.BATCH_CREATE_TASK,
              { data: null },
              selectedItems
            )
          }
        >
          Batch Create Tasks
        </Button>
      ) : null} */}

      <Divider mt={"sm"} />
      {/* <Group>
  <Title order={6} color={'dimmed'}>Rating</Title>
  <Divider />
</Group> */}
      <Group px={"xs"}>
        <FormInputWrapper
          label="Rate"
          id="input-rating"
          labelWidth={80}
          style={{
            marginTop: 12,
            marginBottom: 0,
            ".mantine-Text-root": { marginTop: 0, marginBottom: 0 },
          }}
        >
          <div style={{ marginTop: 4 }}>
            <StarRating
              size={"sm"}
              onChange={(val) =>
                onMenuItemClick(
                  CaptureEventType.RATING_CHANGE,
                  { data: val },
                  selectedItems
                )
              }
            />
          </div>
        </FormInputWrapper>
      </Group>

      <Group px={"xs"}>
        <FormInputWrapper
          label="Flag"
          id="input-rating"
          labelWidth={80}
          style={{ marginTop: 4, marginBottom: 0 }}
        >
          <div style={{ marginTop: 4 }}>
            <FlagToggle
              size={"sm"}
              onChange={(val) =>
                onMenuItemClick(
                  CaptureEventType.STATUS_CHANGE,
                  { data: val },
                  selectedItems
                )
              }
            />
          </div>
        </FormInputWrapper>
      </Group>

      {/* <Group px={'xs'}>
            <FormInputWrapper label='Colour Tag' id='input-colourTag' labelWidth={80} style={{ marginTop: 4, marginBottom: 0 }}>
                <div style={{ marginTop: 4 }}>
                    <ColourTag layout='inline' size={'sm'} color={''} onColourChange={(val) => onMenuItemClick(CaptureEventType.COLOUR_CHANGE, { data: val }, selectedItems)} />
                </div>
            </FormInputWrapper>
        </Group> */}
    </div>
  );
  logger.log(style, "STYLE", selectedAsset);
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Group className="main-container-header">
        <Group position="apart" sx={{ width: "100%" }}>
          <Crumbline items={crumbItems}></Crumbline>
          {/* <Button>Update Season</Button> */}
        </Group>
      </Group>
      <Group
        className="main-container-header"
        justify="space-between"
        align="center"
      >
        <Group style={{ width: "100%" }} justify="space-between">
          {isLoading ? (
            <Group>
              <Skeleton height={30} width={300} />
              <Skeleton height={30} width={50} />
            </Group>
          ) : (
            <Group>
              <Title order={3} lh={"lg"}>
                {style?.name}
              </Title>
              <PrimaryBadge>{style?.department}</PrimaryBadge>
              <Badge
                variant="light"
                color={getStatusColor(style?.clientProdStatus)}
              >
                {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
                {StudioStatusTypes[style?.clientProdStatus].label}
                {/* </Moment> */}
              </Badge>
            </Group>
          )}

          <Group>
            <Popover width={300} position="bottom" withArrow shadow="md">
              <Popover.Target>
                <Button
                  leftSection={
                    <IconAdjustmentsHorizontal
                      size={AppConstants.ICON_SIZE}
                      stroke={AppConstants.ICON_STROKE_WIDTH}
                    />
                  }
                  variant="default"
                >
                  Display Settings
                </Button>
              </Popover.Target>
              <Popover.Dropdown>
                <Paper p="md" radius="sm">
                  <Stack spacing="md">
                    <Select
                      label="Image Fit"
                      description="How the image should fit within its container"
                      data={imageFitOptions}
                      value={displaySettings.imageFit}
                      comboboxProps={{ withinPortal: false }}
                      onChange={(value) =>
                        onChange({ ...displaySettings, imageFit: value })
                      }
                    />

                    <Select
                      label="Size"
                      description="How the image should fit within its container"
                      data={imageSizeOptions}
                      value={displaySettings.imageSize}
                      comboboxProps={{ withinPortal: false }}
                      onChange={(value) =>
                        onChange({ ...displaySettings, imageSize: value })
                      }
                    />

                    <Switch
                      label="Show Meta Information"
                      description="Display additional image metadata"
                      checked={displaySettings.showMeta}
                      onChange={(event) =>
                        onChange({
                          ...displaySettings,
                          showMeta: event.currentTarget.checked,
                        })
                      }
                    />
                  </Stack>
                </Paper>
              </Popover.Dropdown>
            </Popover>

            {/* <Button
              variant="outline"
              leftSection={<IconCheck size={14} />}
              onClick={() => setConfirmationModalOpen(true)}
              disabled={selectedItems.length === 0}
            >
              Mark as Reviewed
            </Button> */}
          </Group>
        </Group>
        {/* <ListToggleControl
          value={listView}
          onChange={(val) => listToggleHandler(val)}
        /> */}
      </Group>
      <Group
        className="container-action-bar"
        style={{ width: "100%" }}
        justify="space-between"
        height={"100%"}
        py="xs"
      >
        <Group>
          <CheckboxDropdown
            selectedItems={selectedItems}
            onCheckboxClick={onSelectAll}
            selectMenu={selectAllMenu}
          />
          <Text order={6} size="sm" my={"xs"}>
            Displaying {style?.assets?.length} Assets
          </Text>
        </Group>

        <Group>
          <Popover
            shadow="sm"
            opened={filterOpen}
            onChange={setFilterOpen}
            width={500}
            withArrow
            closeOnClickOutside={true}
            closeOnEscape={true}
            trapFocus={false}
            position="bottom-end"
            clickOutsideEvents={["mousedown", "touchstart"]}

            // onClose={() => setFilterOpen(false)}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div style={{ display: "flex" }}>
                <CaptureFilterPanel
                  filter={styleMediaFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                  styleCodes={[]}
                  departments={[]}
                />
              </div>
            </Popover.Dropdown>
          </Popover>
        </Group>
        {/* <Group>
          <CheckboxDropdown selectedItems={selectedWips} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} />
          <Input
            leftSection={<IconSearch />}
            style={{ width: 250 }}
            value={styleMediaFilter.keyword}
            onChange={(e) =>
              setStyleFilter({
                ...styleMediaFilter,
                keyword: e.currentTarget.value,
              })
            }
            // placeholder="Filter assets"
            placeholder={`Search across ${wips.length} ${pluralize('Record',wips.length)}`}
            rightSectionPointerEvents="all"
            rightSection={
              <ActionIcon
                variant="transparent"
                onClick={() =>
                  setStyleFilter({
                    ...styleMediaFilter,
                    keyword: "",
                  })
                }
              >
                {styleMediaFilter.keyword.length ? <IconX size={14} /> : null}
              </ActionIcon>
            }
          />
        </Group>
        <Group>
          <Popover
            shadow="sm"
            opened={filterOpen}
            onChange={setFilterOpen}
            width={610}
            withArrow
            closeOnClickOutside={true}
          >
            <Popover.Target>
              <div>
                <FilterButton
                  onClick={filterButtonHandler}
                  onClear={onClearClick}
                  count={filterCount}
                />
              </div>
            </Popover.Target>
            <Popover.Dropdown>
              <div wip={{ display: "flex" }}>
                <FilterPanel
                  filter={styleMediaFilter}
                  onCancel={() => setFilterOpen(false)}
                  onApply={(vals) => {
                    setFilterVars(vals);
                    setFilterOpen(false);
                  }}
                  filterItems={filterItems}
                />
              </div>
            </Popover.Dropdown>
          </Popover>
          {listView !== ListViewOption.CALENDAR ? (
            <Select
              placeholder="Group By"
              value={styleMediaFilter.groupBy}
              onChange={(val) =>
                setStyleFilter({ ...styleMediaFilter, groupBy: val })
              }
              data={[
                { value: "", label: "No Group" },
                { value: "seasonCode", label: "Group by Season" },
                { value: "sessionCode", label: "Group by Session" },
                { value: "dept", label: "Group by Department" },
                { value: "status", label: "Group by Status" },
              ]}
            />
          ) : null}
        </Group> */}
      </Group>

      {/* <Group pt={"lg"} position="apart">
        <Title order={3}>{season?.name}</Title>
        <Group>
          <Menu width={200} shadow="md">
            <Menu.Target>
              <Button>Upload Spreadsheet</Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item onClick={() => onUploadClick("seasons")}>
                Upload Event Styles
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
         
        </Group>
      </Group> */}
      <Grid
        // mb="lg"
        style={{ margin: 0, height: "100%", flexGrow: 1, overflow: "auto" }}
      >
        <Grid.Col h={"100%"} span={12}>
          <div style={{ height: "100%", flex: 1 }}>
            <div style={{ height: "100%" }}>
              <StyleMediaList
                onMediaAction={onMediaAction}
                displaySettings={displaySettings}
                onCaptureChange={onCaptureChange}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                styleMediaFilter={styleMediaFilter}
                setStyleMediaFilter={setStyleMediaFilter}
              />
            </div>
          </div>
        </Grid.Col>

        {/* <Grid.Col></Grid.Col> */}
      </Grid>

      {/* Confirmation Modal for Completing Captures */}
      <Modal
        opened={confirmationModalOpen}
        onClose={() => {
          setConfirmationModalOpen(false);
          setCompletionNotes("");
        }}
        title="Complete Review"
        size="lg"
        centered
      >
        <Stack spacing="md">
          <Text size="sm" c="dimmed">
            You are about to mark the selected images as reviewed. Please add
            any notes below.
          </Text>

          {/* Selected Images Thumbnails */}
          <Box>
            <Text size="sm" fw={500} mb="xs">
              Selected Assets ({selectedItems.length})
            </Text>
            <ScrollArea.Autosize>
              <SimpleGrid cols={4} spacing="xs">
                {selectedItems?.map((item, index) => (
                  <Box key={item.id || index} style={{ position: "relative" }}>
                    <Image
                      src={item.loURL || item.thumbnail || item.src}
                      alt={`Selected image ${index + 1}`}
                      radius="sm"
                      style={{
                        aspectRatio: "1",
                        objectFit: "contain",
                        // border: '2px solid var(--mantine-color-gray-3)',
                      }}
                      fallbackSrc="data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100' height='100' fill='%23f1f3f4'/%3e%3ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999'%3eImage%3c/text%3e%3c/svg%3e"
                    />
                    {/* <Text 
                      size="xs" 
                      style={{
                        position: 'absolute',
                        bottom: 2,
                        right: 2,
                        background: 'rgba(0,0,0,0.7)',
                        color: 'white',
                        padding: '2px 4px',
                        borderRadius: '2px',
                        fontSize: '10px'
                      }}
                    >
                      {index + 1}
                    </Text> */}
                  </Box>
                ))}
              </SimpleGrid>
            </ScrollArea.Autosize>
          </Box>

          {/* Notes Textarea */}
          <Textarea
            label="Review Notes (Optional)"
            placeholder="Add any review notes for these images..."
            value={completionNotes}
            onChange={(event) => setCompletionNotes(event.currentTarget.value)}
            autosize={true}
            minRows={6}
            maxRows={6}
            data-autofocus={true}
          />

          {/* Action Buttons */}
          <Group justify="flex-end" mt="md">
            <Button
              variant="outline"
              onClick={() => {
                setConfirmationModalOpen(false);
                setCompletionNotes("");
              }}
            >
              Cancel
            </Button>
            <Button
              variant="filled"
              leftSection={<IconCheck size={16} />}
              onClick={() => {
                // Execute the completion action
                onMenuItemClick(
                  CaptureEventType.MARK_COMPLETED,
                  {
                    notes: completionNotes,
                    clientProdStatus: StudioStatusTypes.COMPLETE.value,
                    sessionCode: params.sessionId,
                    styleNumber: style.styleNumber,
                  },
                  selectedItems
                );
                // Close modal and reset state
                setConfirmationModalOpen(false);
                setCompletionNotes('');
                setSelectedItems([]);
              }}
            >
              Confirm Completion
            </Button>
          </Group>
        </Stack>
      </Modal>

      <Modal
        opened={imageModalOpen}
        p={0}
        // title={selectedItem.name}
        trapFocus={true}
        closeOnEscape={true}
        id="captureModal"
        withCloseButton={false}
        fullScreen
        onClose={() => setImageModalOpen(false)}
        styles={{
          content: { padding: 0, height: "100vh" },
        }}
      >
        {/* <CaptureDetail
          showSettings={false}
          resoloveImage={false}
          image={selectedAsset}
          src={selectedAsset?.preview}
          onImageEvent={() => logger.log("On image event")}
          onCaptureChange={() => {}}
        /> */}

        <AssetViewer
          style={{
            ...style,
            assets: style?.assets?.map((val) => ({
              ...val,
              preview: val.hiURL,
              thumb: val.loURL,
            })),
          }}
          index={style?.assets?.findIndex(
            (val) => val.id === selectedAsset?.id
          )}
          sessions={
            productionWipList &&
            productionWipList.data &&
            productionWipList.data.length > 0
              ? productionWipList.data.map((val) => {
                  logger.log(val, "val ======", style);
                  return {
                    ...val,
                    code: val.ssSort,
                    isDefault: style.id === val.id,
                  };
                })
              : null
          }
          // index={0}
          onClose={() => setImageModalOpen(false)}
          onCaptureChange={onCaptureChange}
          showSettings={true}
          approvalType={approvalType}
          onFilterChange={(vals) => {
            setFilterVars(vals);
            // the sessionId attribute name is acutally the styleNumber
            if (vals.sessionId && vals.sessionId !== style.id) {
              // onSessionChange(form.values.sessionId);
              // dispatch(fetchStyleMeta(form.values.sessionId, form.values.sessionId));
              // we need to change the url location for the new style id.
              // find the item in the wips list.
              const item = productionWipList.data.find(
                (val) => val.id === vals.sessionId
              );
              logger.log(item, "item");
              if (item) {
                hasInit.current = false;
                dispatch(selectStyle(item));
                navigate(`/wip/production/${item.ssPart}/${item.ssSort}`);
              }
            }
          }}
          approvalFilter={styleMediaFilter}
        />
      </Modal>

      {/* Bottom Action Bar */}
      
        <Paper 
          shadow="xl" 
          radius="lg" 
          p="md"
          className={styles.bottomActionBar}
          
        >
          <Group justify="space-between" align="center">
            <Text size="sm" fw={500}>
              {selectedItems.length} {pluralize('Item',selectedItems.length)} Selected
            </Text>
            
            <Group>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setSelectedItems([])}
              >
                Cancel
              </Button>
              
              <Button
                variant="filled"
                size="sm"
                leftSection={<IconCheck size={16} />}
                disabled={selectedItems.length === 0}
                onClick={() => setConfirmationModalOpen(true)}
              >
                Mark as Reviewed
              </Button>
            </Group>
          </Group>
        </Paper>
      </div>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    styleMediaFilter: state.wipReducer.styleMediaFilter,
    style: state.wipReducer.selectedStyle,
    assets: state.wipReducer.assets,
    success: state.wipReducer.success,
    productionWipList: state.wipReducer.productionWipList,
    // season: state.seasonReducer.selectedSeason,
    // success: state.seasonReducer.success,
    // error: state.seasonReducer.error,
  };
};

const mapDispatch = { setStyleMediaFilter };

export default connect(mapStateToProps, mapDispatch)(Style);

const FilterPanel = ({ onCancel, onApply, filter, filterItems, user }) => {
  const form = useForm({
    initialValues: {
      ...filter,
      // status:{
      //     sampleCount:filter.status.sampleCount.toString(),
      //     photographyCount:filter.status.photographyCount.toString(),
      //     taskCount:filter.status.taskCount.toString(),
      //     taskCompletedCount:filter.status.taskCompletedCount.toString()
      // }
    },
  });

  useEffect(() => {
    if (filter && form) {
      form.setValues({ ...filter });
    }
  }, [filter]);

  const getFilterVars = useCallback(
    (key) => {
      var res = [];
      if (filterItems[key])
        Object.keys(filterItems[key]).forEach((val) => res.push(val));
      return res.sort((a, b) =>
        a.localeCompare(b, undefined, { numeric: true })
      );
    },
    [filter, filterItems]
  );

  return (
    <Box shadow="xs" wip={{ width: "100%" }}>
      <form onSubmit={form.onSubmit((values) => onApply(values))}>
        <ScrollArea h={400} wip={{ overflowX: "hidden" }}>
          <Box>
            <FormInputWrapper label="Wip" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("wipsCodes")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("wipsCodes")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Department" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("depts")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("departments")}
              />
            </FormInputWrapper>

            <FormInputWrapper
              label="Status"
              id="input-status"
              labelWidth={"120px"}
            >
              <MultiSelect
                data={getFilterVars("statuses")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("statuses")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Events" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("seasons")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("seasons")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Sessions" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("sessions")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("sessions")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Issuers" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("issuers")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("issuers")}
              />
            </FormInputWrapper>

            <FormInputWrapper label="Talent" labelWidth={"120px"}>
              <MultiSelect
                data={getFilterVars("talents")}
                label=""
                placeholder="Pick all that you like"
                searchable
                nothingFound="Nothing found"
                {...form.getInputProps("talents")}
              />
            </FormInputWrapper>

            <FormInputWrapper
              label={getClientLabel(user.clientCode, 'otbDate')}
              id="input-otbDate"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder={`From ${getClientLabel(user.clientCode, 'otbDate')}`}
                  {...form.getInputProps("otbDate.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder={`To ${getClientLabel(user.clientCode, 'otbDate')}`}
                  {...form.getInputProps("otbDate.dateEnd")}
                />
              </Group>
            </FormInputWrapper>

            <FormInputWrapper
              label="Completed Date"
              id="input-completed"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="From Completed Date"
                  {...form.getInputProps("completed.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="To Completed Date"
                  {...form.getInputProps("completed.dateEnd")}
                />
              </Group>
            </FormInputWrapper>

            <FormInputWrapper
              label="Distribution Date"
              id="input-completed"
              labelWidth={"120px"}
            >
              <Group wrap="nowrap">
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="From Distribution Date"
                  {...form.getInputProps("distribution.dateStart")}
                />
                <Text>to</Text>
                <CustomDatePicker
                  sx={{ width: 190 }}
                  placeholder="To Distribution Date"
                  {...form.getInputProps("distribution.dateEnd")}
                />
              </Group>
            </FormInputWrapper>
          </Box>
        </ScrollArea>

        <Group justify="space-between" mt="lg">
          <Button
            variant="subtle"
            component="button"
            size="sm"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button type="submit" size="sm">
            Apply
          </Button>
        </Group>
      </form>
    </Box>
  );
};

const imageFitOptions = [
  { value: "cover", label: "Cover" },
  { value: "contain", label: "Contain" },
];

const imageSizeOptions = [
  { value: "200", label: "Small" },
  { value: "300", label: "Medium" },
  { value: "400", label: "Large" },
  { value: "600", label: "XLarge" },
];
